import React, { useState } from 'react';
import GenericButton from '../../components/GenericButton'; // Import the GenericButton
import { ResultTime } from '../../models/ResultTimes';

interface AddResultTimePageProps {
  onSave: (value: any) => void;  // Save callback function
  data: ResultTime;  // Game data for editing
}

const AddResultTimePage: React.FC<AddResultTimePageProps> = ({ data, onSave }) => {
  console.log(data); // To check the incoming data

  // Form state
  const [resultTime, setResultTime] = useState<ResultTime>(data);

  // Form error state
  const [errors, setErrors] = useState({
    name: '',
  });

  // Validation function for name
  const validateName = (value: string) => {
    return value.trim() === '' ? 'Name is required' : '';
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission

    // Validate the form
    const nameError = validateName(resultTime.resultTime);

    if (nameError) {
      setErrors({ name: nameError });
      return; // Prevent form submission if there are validation errors
    }

    // If no errors, call the onSave prop to save the game
    onSave(resultTime);
  };

  return (
    <div className="container mt-4">
      <form onSubmit={handleSubmit}> {/* Correct form submission handler */}
        <div className="mb-3">
          <label className="form-label">Result Time</label>
          <input
            type="time"
            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
            value={resultTime.resultTime}
            onChange={(e) => {
              setResultTime({
                ...resultTime,
                resultTime: e.target.value,
              });
              setErrors({ ...errors, name: '' }); // Clear error when input changes
            }}
            required
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>
        
        {/* Replace standard button with GenericButton */}
        <GenericButton
          label="Save"
          onClick={() => handleSubmit} // Trigger handleSubmit on click
          disabled={resultTime?.resultTime?.trim() === ''} // Disable button if the name is empty
          type="primary" // You can change this to 'secondary' if needed
        />
      </form>
    </div>
  );
};

export default AddResultTimePage;
